import React, { Component } from 'react';
import ButtonNumList from '../ButtonNumList/ButtonNumList';
import Strings from 'localization/Strings';
import './Button10.css';

class Button10 extends Component {
    groupText(){
        let N = this.props?.groups?.length ?? 0;
        let fields = [];
        for (let index = 0; index < N; index++) {
            let element = this.props.groups[index];
            fields.push(<p key={element} className="spanTitle">{element}</p>);
        }
        return fields;
    }

    render () {
    return (
        <div className='num10-container'>
            <div className='spanContainer'>
                {this.groupText()}
            </div>
            <div className='pt20'>
                <ButtonNumList min="0" max="10" onChanged={(selectedValue) => this.props?.onChanged(selectedValue)} />
            </div>
        </div>
    )
    } 
}

export default Button10;